import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BsSquare, BsCheckSquare } from 'react-icons/bs';

import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useFocus } from '../utility/hooks/hooks';
import { toast, Toaster } from 'sonner';
import {
  selectISFirebaseSocketOn,
  selectWidth,
} from '../utility/Redux/profile';
import { Eye, EyeOff, Lock, Mail } from 'lucide-react';
import {
  setAlertMsg,
  setALertStatus,
  setAlertWithTitle,
  setCheckEmailAlert,
  setloading,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import AlertModal from '../utility/component/modals/alert';
import CheckEmailModall from '../utility/component/modals/resetPassword';
import EmailVerify from '../utility/component/modals/verifyEmailModal';
import Gicon from '../utility/images/go_logo.svg';
import EmailVerified from '../utility/component/modals/emailVerified';

import CryptoJS from 'crypto-js';
import { UserLogin } from '../utility/component/buttons';
import AlertModal2 from '../utility/component/modals/alertWithLottie';
import ForgetModel from './forgetModel';
import RoutbillingLogo from '../utility/component/styles/routbillingLogo';
import SpinnerLoading from '../utility/component/modals/spinnerLoading';
import AlertModalTwoButton from '../utility/component/modals/alertWithTwoButton';
import { emailRegex, mobileRegex, primaryColor } from '../utility/constant';
import { isSubdomain, moveHome, runLoginFunc } from './func';
import {
  selectExpireAt,
  selectLoginData,
  selectOtpModalStatus,
  selectRandomOtp,
  selectUserData,
  setOtpMobile,
  setOtpStatus,
} from '../utility/Redux/security';
import OtpAlertModal from '../utility/component/modals/otpAlertModal';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';
import LicenseExpiredModal from './licenseExpireModal';
import Navbar from './navBar';
import Footer from '../components/faq';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../components/card';
import { Label } from '../components/Label';
import { Button } from '../components/Button';
import { Input } from '../components/input';
const secretPass = process.env.REACT_APP_SECRET_KEY;

export const Login = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const isFirebaseSocket = useSelector(selectISFirebaseSocketOn);
  const userName = searchParams.get('userName');
  const [licenseExpiredStatus, setLicenseExpiredStatus] = useState(false);
  const searchpswrd = searchParams.get('password');
  const [remember, setRember] = useState(false);
  const currentUrl = window.location.href;
  const windowWiidt = useSelector(selectWidth);
  const [passRef, setPasswordFocus] = useFocus();
  const [hidden, sethidden] = useState(true);
  const [email, setEmail] = useState(userName ? userName : '');
  const [password, setPassword] = useState(searchpswrd ? searchpswrd : '');
  const [forget, setForget] = useState(false);
  const [emailBordered, setEmailLoginBordered] = useState('gray');
  const [PasswordBordered, setPasswordBordered] = useState('gray');
  const move = useNavigate();
  const [subDomain, setSubDomain] = useState('');
  const otpStatus = useSelector(selectOtpModalStatus);
  const randomOTP = useSelector(selectRandomOtp);
  const [alertTwoButtonModal, setAlertTwoButtonModal] = useState({
    title: '',
    msg: '',
    status: false,
    setStatus: '',
    button1: '',
    button1Click: '',
    button2: '',
    button2Click: '',
  });
  const loginData = useSelector(selectLoginData);
  const userData = useSelector(selectUserData);
  const expireAt = useSelector(selectExpireAt);
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    if (currentUrl.includes('shopkeeper')) {
      move('/auth/shopkeeper_login');
    }
  }, []);

  const initialValues = {
    Email: '',
    login_password: '',
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const isRemmberd = JSON.parse(localStorage.getItem('rememberd'));

    if (isRemmberd) {
      const bytes = CryptoJS.AES.decrypt(isRemmberd.email, secretPass);
      const bytes2 = CryptoJS.AES.decrypt(isRemmberd.password, secretPass);

      if (bytes.sigBytes < 0 || bytes2.sigBytes < 0) {
        localStorage.removeItem('rememberd');
      } else {
        const decEmail = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        const decPass = JSON.parse(bytes2.toString(CryptoJS.enc.Utf8));

        setEmail(decEmail);
        setPassword(decPass);
        setRember(true);
      }
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => sethidden(true), 1000);
    return () => clearTimeout(timer);
  }, [hidden]);

  useEffect(() => {
    localStorage.removeItem('stationName');
    localStorage.removeItem('stationId');
    localStorage.removeItem('billDetails');
    localStorage.removeItem('userName');
    localStorage.removeItem('count');
    localStorage.removeItem('tkn');
    localStorage.removeItem('company');
    localStorage.removeItem('histryId');
    localStorage.removeItem('prefix');
    // localStorage.removeItem('expiresAt');
    localStorage.removeItem('orderdItemList');
    localStorage.removeItem('userType');
    localStorage.removeItem('companyDetails');
    localStorage.removeItem('allowedPages');
  }, []);

  const loginApi = () => {
    dispatch(setSpinnerLoading('Checking username'));

    if (emailRegex.test(email) || mobileRegex.test(email)) {
      const secretPass = process.env.REACT_APP_AUTH_SECRET_KEY;
      // const hmac = CryptoJS.HmacSHA256(message, secret);
      const hmac = CryptoJS.HmacSHA256(email, secretPass);
      // Convert the HMAC to a string and encode it using Base64
      const hmacString = hmac.toString(CryptoJS.enc.Base64);
      let userEmail = emailRegex.test(email) ? email : '';
      let userMobile = mobileRegex.test(email) ? email : '';

      if (password.length >= 5) {
        runLoginFunc(
          userEmail,
          userMobile,
          hmacString,
          isFirebaseSocket,
          dispatch,
          password,
          remember,
          move,
          setLicenseExpiredStatus
        );
      } else {
        dispatch(setSpinnerLoading(false));

        if (password) {
          toast.warning('Incorrect password');
        } else {
          toast.warning('Invalid password');
        }
      }
    } else {
      dispatch(setSpinnerLoading(false));
      toast.warning('Invalid email or mobile');
    }
  };

  const forgetModel = (e) => {
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneRegex = /^[6-9]\d{9}$/;
    if (re.test(e)) {
      setForget(true);
    } else {
      dispatch(
        setAlertMsg('Enter valid user email address for change password')
      );
      dispatch(setALertStatus(true));
    }
  };

  const forgetPassword = (emailCheck) => {
    const secretPass = process.env.REACT_APP_AUTH_SECRET_KEY;

    // const hmac = CryptoJS.HmacSHA256(message, secret);
    const hmac = CryptoJS.HmacSHA256(email, secretPass);
    // Convert the HMAC to a string and encode it using Base64
    const hmacString = hmac.toString(CryptoJS.enc.Base64);
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneRegex = /^[6-9]\d{9}$/;
    if (re.test(emailCheck) || phoneRegex.test(emailCheck)) {
      dispatch(setloading(true));

      CallAPIPromise(
        '/api/users/findUserDetail',
        {
          user_email: !phoneRegex.test(emailCheck) ? emailCheck : '',
          user_mobile: phoneRegex.test(emailCheck) ? emailCheck : '',
        },
        hmacString,
        dispatch
      )
        .then((res) => {
          if (res.data[0]) {
            CallAPIPromise(
              `/api/users/resetUserPasswordEmail`,
              {
                user_email: !phoneRegex.test(emailCheck) ? emailCheck : '',
                user_name: res.data[0].user_name,
                user_mobile: phoneRegex.test(emailCheck) ? emailCheck : '',
              },
              hmacString,
              dispatch
            )
              .then((r) => {
                dispatch(setCheckEmailAlert(true));
                // move('/auth/checkEmail')
              })
              .catch((err) => {
                dispatch(setAlertMsg(err.code + ' ' + err.message));
                dispatch(setALertStatus(true));
              })
              .finally(() => {
                dispatch(setloading(false));
              });
          } else {
            dispatch(setAlertMsg('Not registered user'));
            dispatch(setALertStatus(true));
          }
        })
        .catch((e) => {
          dispatch(setAlertMsg('Something wrong'));
          dispatch(setALertStatus(true));
        });
    } else {
      dispatch(setAlertMsg('Invailed email address'));
      dispatch(setALertStatus(true));
    }
  };

  useEffect(() => {
    const currentURL = window.location.href;

    setSubDomain(isSubdomain(currentURL));
  }, []);
  useEffect(() => {
    if (indexedDB.databases) {
      indexedDB
        .databases()
        .then((databases) => {
          databases.forEach((dbInfo) => {
            if (dbInfo.name !== 'SaveIssueCart') {
              if (dbInfo.name !== 'Calculations') {
                indexedDB.deleteDatabase(dbInfo.name);
              }
            }
          });
        })
        .catch((error) => {
          console.error('Error listing databases:', error);
        });
    } else {
      // Fallback method for browsers that do not support indexedDB.databases()
      console.log('indexedDB.databases() is not supported in this browser.');
    }
  }, []);
  const handleSubmit = () => {};
  const footerRef = useRef();
  console.log(footerRef?.current?.offsetHeight);
  return (
    <div className="h-screen">
      <Navbar isShowShadow={true} />
      <div
        style={{
          height: `calc(100% - ${footerRef?.current?.offsetHeight}px)`,
          minHeight:600
        }}
        className="flex-col  bg-gray-100 flex items-center justify-center p-4 pt-32 pb-16"
      >
        <div className="w-full max-w-md">
          {/* Header Section */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Welcome back
            </h1>
            <p className="text-gray-600">Sign in to your account to continue</p>
          </div>

          {/* Login Card */}
          <Card className="shadow-lg border-0 bg-white">
            <CardContent className="p-8">
              <form onSubmit={handleSubmit} className="space-y-6 pb-3">
                <div className="space-y-2">
                  <Label
                    htmlFor="email"
                    className="text-sm font-medium text-gray-700"
                  >
                    Email address
                  </Label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                    <Input
                      id="email"
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value.toLowerCase())}
                      className="pl-10 h-11 border-gray-300 focus:border-primary-blue focus:ring-1 focus:ring-primary-blue transition-colors"
                      required
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <Label
                    htmlFor="password"
                    className="text-sm font-medium text-gray-700"
                  >
                    Password
                  </Label>
                  <div className="relative">
                    <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                    <Input
                      id="password"
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="pl-10 pr-10 h-11 border-gray-300 focus:border-primary-blue focus:ring-1 focus:ring-primary-blue transition-colors"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                      {showPassword ? (
                        <EyeOff className="w-4 h-4" />
                      ) : (
                        <Eye className="w-4 h-4" />
                      )}
                    </button>
                  </div>
                </div>

                <div className="flex items-center justify-between text-sm">
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={remember}
                      onChange={(e) => setRember(e.target.checked)}
                      className="w-4 h-4 rounded border-gray-300 focus:ring-primary-blue accent-primary-blue"
                    />
                    <span className="text-gray-600">Remember me</span>
                  </label>
                  <button
                    type="button"
                    onClick={() => {
                      if (email) {
                        forgetModel(email);
                      } else {
                        toast.warning(
                          'Please enter user email address for change password'
                        );
                      }
                    }}
                    className="text-primary-blue hover:underline transition-colors"
                  >
                    Forgot password?
                  </button>
                </div>

                <Button
                  type="button"
                  onClick={() => {
                    loginApi();
                  }}
                  style={{
                    backgroundColor: primaryColor,
                  }}
                  className="w-full h-11  text-white  transition-colors shadow-sm"
                >
                  Sign in
                </Button>
              </form>

              {/* <div className="relative my-6">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-300"></div>
                </div>

                <div className="relative flex justify-center text-xs uppercase">
                  <span className="bg-white px-3 text-gray-500">
                    Or continue with
                  </span>
                </div>
              </div> */}

              {/* <Button
                variant="outline"
                className="w-full h-11 border-gray-300 hover:bg-gray-50 transition-colors"
              >
                <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24">
                  <path
                    fill="#4285F4" // Blue
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853" // Green
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05" // Yellow
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335" // Red
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                Continue with Google
              </Button> */}
            </CardContent>
          </Card>
        </div>
      </div>
      <AlertModal />
      <LicenseExpiredModal
        isOpen={licenseExpiredStatus}
        onClose={() => {
          setLicenseExpiredStatus(false);
        }}
      />
      <ForgetModel
        forget={forget}
        setForget={setForget}
        forgetPassword={forgetPassword}
        email={email}
      />
      <CheckEmailModall />
      <EmailVerify email={location.state} />
      <AlertModalTwoButton
        details={alertTwoButtonModal}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
      />
      <EmailVerified />
      <SpinnerLoading />
      <OtpAlertModal
        status={otpStatus}
        otp={randomOTP}
        onCancel={() => {
          dispatch(setOtpStatus(false));
        }}
        onSubmit={() => {
          dispatch(setOtpStatus(false));

          moveHome(
            {
              data: {
                token: loginData.token,
                data: [
                  {
                    ...loginData,
                  },
                ],
              },
            },
            userData,
            expireAt,
            dispatch,
            remember,
            password,
            move
          );
        }}
      />
      <Footer footerRef={footerRef} onlyFooter={true} />
      <Toaster position="top-center" />
    </div>
  );
};
